import { useState, useRef } from 'react';

export const useCounter = ({
  start,
  end,
  interval = 1000,
  step = 1,
  onCompleted,
}) => {
  const [counter, setCounter] = useState(start);
  const [counterStatus, setCounterStatus] = useState(false);
  const holder = useRef({
    intervalId: null,
    counter,
  }).current;

  holder.counter = counter;

  const startCounter = () => {
    resetCounter();

    setCounterStatus(true);

    holder.intervalId = setInterval(() => {
      const asc = end > start;
      const newCounterValue = asc
        ? holder.counter + step
        : holder.counter - step;
      const mustStop = asc ? newCounterValue > end : newCounterValue < end;

      if (!mustStop) {
        setCounter(newCounterValue);
      } else {
        clearInterval(holder.intervalId);
        setCounterStatus(false);
        onCompleted && onCompleted();
      }
    }, interval);
  };

  const stopCounter = () => {
    clearInterval(holder.intervalId);
    setCounterStatus(false);
    setCounter(end);
    onCompleted && onCompleted();
  };

  const resetCounter = () => {
    setCounter(start);
    clearInterval(holder.intervalId);
  };

  return {
    timer: counter,
    counter: sec2time(counter),
    counterStatus,
    startCounter,
    stopCounter,
  };
};

// https://gist.github.com/vankasteelj/74ab7793133f4b257ea3
const sec2time = (timeInSeconds) => {
  const pad = function (num, size) {
    return ('000' + num).slice(size * -1);
  };
  const minutes = Math.floor(timeInSeconds / 60) % 60;
  const seconds = Math.floor(timeInSeconds - minutes * 60);

  return pad(minutes, 2) + ':' + pad(seconds, 2);
};
